import {
  RetailItemSaleService,
  RetailSaleEndpoint
} from './retail-item-sale.service';
import { ApiClient } from '../api.client';
import { Injectable } from '@angular/core';

@Injectable()
export class BookingRetailItemSaleService extends RetailItemSaleService {
  protected docketTypePrefix = 'booking' as RetailSaleEndpoint;

  constructor(protected http: ApiClient) {
    super(http);
  }
}
